var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0325 8.31184C15.0157 8.31184 13.6626 9.41847 13.1099 10.4677H13.0517V8.64699H9.07438V21.9992H13.2161V15.3876C13.2161 13.6466 13.5462 11.9634 15.702 11.9634C17.8262 11.9634 17.8579 13.9501 17.8579 15.4993V22H21.9953V21.9992H22V14.6641C22 11.0759 21.2274 8.31184 17.0325 8.31184Z",
    fill: "#0E7139"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.47645 8.64741H2.33002V21.9996H6.47645V8.64741Z",
    fill: "#0E7139"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.40153 2C3.07577 2 2 3.07577 2 4.40154C2 5.72731 3.07577 6.82574 4.40153 6.82574C5.7273 6.82574 6.80306 5.72731 6.80306 4.40154C6.80228 3.07577 5.72652 2 4.40153 2Z",
    fill: "#0E7139"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.2057365aa771c13b8ce27e80994e12a3.svg";
export { ForwardRef as ReactComponent };